/**
 * Created by rlopez on 08/11/16.
 */

import $ from 'jquery';

import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';

import constants    from 'Constants.js';
import undoService from 'UndoService.js';
import util        from 'util/Util.js';
import textConstants    from 'TextConstants';
import listService from 'ListService.js';

const ICON_EMPTY = constants.DB_ICON_EMPTY;

//==========================================================================================
// This singleton controller handles resizing a control by dragging its borders.
//==========================================================================================
class CustomListController{

    constructor() {

    }

    createNew(mainView){
        return new Promise((resolve, reject) => {
            this.addList(mainView).then((listId) => {
                undoService.add({
                    undo: () => {
                        this.deleteList(mainView, listId);
                    },
                    redo: () => {
                      this.undeleteCustomList(mainView,listId);
                    }
                }, textConstants.UNDO_NEW_LIST);
                util.setUndoRedoAccess();
                resolve(listId);
            }).catch(reject);
        });
    }
   
    addList(mainView){
        return new Promise((resolve, reject) => {
        RestService.addCustomList().then((data)=>{            
            const listId = data.RESULT.RESPONSE.CustomListId;
            this.expandUpdatedCustomListAndDetailView(mainView,listId);
            resolve(listId);
        }).catch((err)=> {            
            NotificationService.error('Error Creating New Custom List' + err.MESSAGE);
            reject();
        });
    });
    }

    undeleteCustomList(mainView, listId){
        return new Promise((resolve, reject) => {
        RestService.undeleteCustomList(listId).then((data)=>{
            if (listService.activeDashboardTab === 'settings'){                      
              this.expandUpdatedCustomListAndDetailView(mainView,listId);
            }
            resolve(listId);
        }).catch((err)=> {            
            NotificationService.error('Error Restoring Custom List' + err.MESSAGE);
            reject();
        });
    });
    }

    deleteList(mainView, listId){
        RestService.deleteCustomList(listId).then((response)=>{
            if (listService.activeDashboardTab === 'settings'){ 
               const $element = $(`a[data-itemid$='${listId}']`);
               const itemId = $element.attr('data-itemid');
               $element.parent().remove();
               mainView.cleanDetailView();
            }
        }).catch((err)=> {           
            NotificationService.error('Error Deleting CustomList' + err.MESSAGE);
        });
    }

    expandUpdatedCustomListAndDetailView(mainView,listId){
        RestService.browseCustomList(listId).then((data)=>{
            this.renderListItems(mainView,data,0,'ListsGroup',constants.LISTS_GROUP_CONTAINER);
            if(listId) {
                $(constants.LISTS_GROUP_CONTAINER).collapse('show');               
                $('li[role="button"]').removeClass('bg-success');
                $(`i[data-itemid="${listId}"]`).parent('li').addClass('bg-success');
                mainView.renderListDetailsView(listId);           
            }
            else{
                mainView.cleanDetailView();
            }

        }).catch((err)=> {            
            NotificationService.error('Error Retrieving updated custom list items' + err.MESSAGE);
        });
    }

    renderListItems(mainView,data,groupType,itemId,dataTarget){
        console.log("Custom List Data",data);
        let nodes = [];
        if ((data && data.length > 0) || (data && !$.isEmptyObject(data))) {
            let customLists = data instanceof Array ? data : [data];
                 nodes = this.loadCustomListsFromResponse(customLists);
        }
        else{
            nodes = [{
                nodeName: 'no items',
                url: '#',
                icon: ICON_EMPTY,
                id: 0,
                groupType: groupType,
                nodeType: '',
                hasChildren: false
            }]
        }

        var group = mainView.replaceGroupItemsInModel('settingsSections', 'Account Settings',itemId,nodes);


        mainView.addItemsToGroup(group, dataTarget);
    }

    loadCustomListsFromResponse(customLists) {
        var nodes = [];

        for(let customList of customLists) {
            nodes.push({
                nodeName:customList['@Name'],
                url: '#',
                icon: ICON_EMPTY,
                id: customList['@CustomListId'],
                groupType: constants.SETTINGS_RESOURCES_LISTS,
                nodeType: 'listItem', //connection["@Type"],
                hasChildren: false,
                toggleIcon: ''
            });
        }
        return nodes;
    }
}

const customListController = new CustomListController();
export default customListController;
